import { InjectionToken } from '@angular/core';
import { IApiEndpointResolver } from './api-endpoint-resolver.interface';

export const API_ENDPOINT_RESOLVER = new InjectionToken<IApiEndpointResolver>(
  'API_ENDPOINT_RESOLVER'
);
